/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';
import { TableCell } from 'components';
import { useCallback } from 'react';

export const ContentHeader = ({ updateSortConfig, getSortDirection }) => {
  return (
    <StyledContainer>
      <TableCell.Component
        width={240}
        size={TableCell.sizes[32]}
        value='pbaName'
        onClick={updateSortConfig}
        direction={getSortDirection('pbaName')}
      >
        Application
      </TableCell.Component>
      <TableCell.Component
        width={150}
        size={TableCell.sizes[32]}
        value='renderedCountries'
        onClick={updateSortConfig}
        direction={getSortDirection('renderedCountries')}
      >
        {/* Active
          <br />
          Campaigns Geo&apos;s */}
      </TableCell.Component>
      <TableCell.Component
        width={120}
        size={TableCell.sizes[32]}
        value='activeCampaigns'
        onClick={updateSortConfig}
        direction={getSortDirection('activeCampaigns')}
      >
        Active
        <br />
        Campaigns
      </TableCell.Component>
      <TableCell.Component
        width={100}
        size={TableCell.sizes[32]}
        value='monthlyBudget'
        onClick={updateSortConfig}
        direction={getSortDirection('monthlyBudget')}
      >
        Budget
      </TableCell.Component>
      <TableCell.Component
        width={140}
        size={TableCell.sizes[32]}
        value='budgetToUse'
        onClick={updateSortConfig}
        direction={getSortDirection('budgetToUse')}
      >
        Remaining budget
      </TableCell.Component>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding: 8px 24px;
  display: flex;
  user-select: none;
  background: ${Palette.PrimaryGray._000};
`;
